import { useEffect } from 'react';

import {
  clearForgotPasswordError,
  clearIsForgotPasswordSuccess,
  forgotPassword,
  useSelectForgotPasswordError,
  useSelectIsForgotPasswordSuccess
} from 'Auth/data';
import { useAppDispatch } from 'Store';

import type { IForgotPasswordRequest } from '@libs/models';

import { ForgotPasswordForm } from './ForgotPasswordForm';

type Props = {
  email?: string;
};

export const ForgotPasswordFormContainer = ({ email }: Readonly<Props>) => {
  const dispatch = useAppDispatch();
  const isForgotPasswordSuccess = useSelectIsForgotPasswordSuccess();
  const forgotPasswordError = useSelectForgotPasswordError();

  const handleSubmit = (values: IForgotPasswordRequest) => {
    dispatch(forgotPassword(values));
  };

  useEffect(() => {
    dispatch(clearIsForgotPasswordSuccess());
    dispatch(clearForgotPasswordError());
  }, [dispatch]);

  return (
    <ForgotPasswordForm
      onSubmit={handleSubmit}
      email={email}
      isSubmitSuccess={isForgotPasswordSuccess}
      error={forgotPasswordError}
    />
  );
};
